module.exports = __webpack_public_path__ + "img/badge-best-writer.e0054984.png";